module.exports = __webpack_public_path__ + "static/img/t1-2-3.10c7cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-2-3.png
// module id = P2P9
// module chunks = 1